<template>
    <div>
        <Navbar />
        <PageTitle
            pageTitle="Impressum"
            pageDesc="Rechtliche Informationen"
        />
        <div class="legal-area ptb-100">
            <div class="container">
                <div class="legal-content">
                    <h3>Angaben gemäß § 5 ECG</h3>

                    <div class="legal-section">
                        <h4>Unternehmensbezeichnung</h4>
                        <p>
                            <strong>Benovium e.U.</strong><br>
                            Inhaber: Bernhard Wallner
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Anschrift</h4>
                        <p>
                            Antonigasse 44/5<br>
                            1180 Wien<br>
                            Österreich
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Kontakt</h4>
                        <p>
                            Telefon: <a href="tel:+436605782160">+43 660 578 2160</a><br>
                            E-Mail: <a href="mailto:office@benovium.com">office@benovium.com</a><br>
                            Website: <a href="https://benovium.com">www.benovium.com</a>
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Unternehmensgegenstand</h4>
                        <p>
                            Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Firmenbuch</h4>
                        <p>
                            Firmenbuchnummer: FN 670010i<br>
                            Firmenbuchgericht: Handelsgericht Wien<br>
                            UID-Nummer: ATU82879716
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Kammermitgliedschaft</h4>
                        <p>
                            Mitglied der WKÖ, Wirtschaftskammer Wien<br>
                            Fachgruppe UBIT (Unternehmensberatung, Buchhaltung und Informationstechnologie)
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Berufsrecht</h4>
                        <p>
                            Gewerbeordnung 1994: <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener">www.ris.bka.gv.at</a>
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Aufsichtsbehörde</h4>
                        <p>
                            Magistrat der Stadt Wien (MA 63)
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Verbraucherstreitbeilegung</h4>
                        <p>
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                            Verbraucherschlichtungsstelle teilzunehmen.
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Haftungsausschluss</h4>
                        <p>
                            <strong>Haftung für Inhalte:</strong><br>
                            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
                            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                        </p>
                        <p>
                            <strong>Haftung für Links:</strong><br>
                            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
                            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
                            Seiten verantwortlich.
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>Urheberrecht</h4>
                        <p>
                            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
                            dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede
                            Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
                            Zustimmung des jeweiligen Autors bzw. Erstellers.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import Navbar from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import Footer from '../Layouts/Footer';

export default {
    name: 'ImpressumPage',
    setup() {
        useHead({
            title: 'Impressum - Benovium',
            meta: [
                { name: 'description', content: 'Impressum von Benovium e.U. - Bernhard Wallner, Wien. Rechtliche Informationen gemäß § 5 ECG.' },
                { name: 'robots', content: 'noindex, follow' },
                { property: 'og:title', content: 'Impressum - Benovium' },
                { property: 'og:url', content: 'https://benovium.com/impressum' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/impressum' }
            ]
        });
    },
    components: {
        Navbar,
        PageTitle,
        Footer
    }
}
</script>

<style scoped>
.legal-area {
    background: #f8f9fa;
}

.legal-content {
    max-width: 800px;
    margin: 0 auto;
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.05);
}

.legal-content h3 {
    font-size: 28px;
    margin-bottom: 30px;
    padding-bottom: 15px;
    border-bottom: 2px solid #6a11cb;
}

.legal-section {
    margin-bottom: 25px;
}

.legal-section h4 {
    font-size: 18px;
    color: #1a1a2e;
    margin-bottom: 10px;
}

.legal-section p {
    color: #666;
    line-height: 1.8;
    margin-bottom: 10px;
}

.legal-section a {
    color: #6a11cb;
}

.legal-section a:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .legal-content {
        padding: 20px;
    }

    .legal-content h3 {
        font-size: 22px;
    }
}
</style>
